(function () {
  // October 2026 "Build Your Routine" campaign — free Print Bonnet (Malia)
  // auto-added only when The Complete Afrocenchix Routine is in the cart.
  var TRIGGER_VARIANT_IDS = [
    32806929498159   // The Complete Afrocenchix Routine
  ];

  var FREE_ITEM_VARIANT_IDS = [
    32828699967535   // Print Bonnet with Satin Lining — Malia
  ];

  var SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  var isHandling = false;

  function getCart() {
    return fetch('/cart.js').then(function (res) { return res.json(); });
  }

  function hasTriggerInCart(cart) {
    return cart.items.some(function (item) {
      return TRIGGER_VARIANT_IDS.indexOf(item.variant_id) !== -1;
    });
  }

  function freeItemsInCart(cart) {
    return cart.items.filter(function (item) {
      return FREE_ITEM_VARIANT_IDS.indexOf(item.variant_id) !== -1;
    });
  }

  // Fetch fresh section HTML and re-render the mini-cart drawer in-place.
  function refreshMiniCart() {
    var miniCart = document.querySelector('mini-cart');
    if (!miniCart) { location.reload(); return; }

    fetch(window.location.pathname + '?sections=' + SECTIONS.join(','))
      .then(function (res) { return res.json(); })
      .then(function (sectionData) {
        miniCart.renderContents({ sections: sectionData });
      })
      .catch(function () { location.reload(); });
  }

  function handleBonnetGWP() {
    if (isHandling) return;
    isHandling = true;

    getCart().then(function (cart) {
      var triggerPresent = hasTriggerInCart(cart);
      var presentFreeItems = freeItemsInCart(cart);

      if (!triggerPresent) {
        // Complete Routine not in cart — remove the free bonnet if it's there
        if (presentFreeItems.length === 0) {
          isHandling = false;
          return;
        }

        Promise.all(presentFreeItems.map(function (item) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        })).then(function () {
          isHandling = false;
          refreshMiniCart();
        }).catch(function () { isHandling = false; });

        return;
      }

      // Complete Routine is in cart — add the free bonnet if missing
      var presentVariantIds = presentFreeItems.map(function (i) { return i.variant_id; });
      var missingItems = FREE_ITEM_VARIANT_IDS.filter(function (vid) {
        return presentVariantIds.indexOf(vid) === -1;
      });

      if (missingItems.length === 0) {
        isHandling = false;
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: missingItems.map(function (vid) { return { id: vid, quantity: 1 }; })
        })
      }).then(function () {
        isHandling = false;
        refreshMiniCart();
      }).catch(function () { isHandling = false; });

    }).catch(function () {
      isHandling = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    handleBonnetGWP();

    // Watch the mini-cart element for DOM updates (covers homepage add-to-cart
    // paths that don't publish the cart-update pub/sub event).
    var miniCartContent = document.getElementById('mini-cart');
    if (miniCartContent) {
      var observer = new MutationObserver(function () {
        handleBonnetGWP();
      });
      observer.observe(miniCartContent, { childList: true });
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleBonnetGWP);
  }
})();
